import { Route } from 'react-router-dom';
import PaymentHistoryPage from '../pages/PaymentHistoryPage';
import PaymentDetailPage from '../pages/PaymentDetailPage';

export const PaymentRoutes = () => (
    <>
        <Route path="billing" element={<PaymentHistoryPage />} />
        <Route path="payment/:id" element={<PaymentDetailPage />} />
    </>
);
